import React from 'react';
import './styles/UI.css';

const WelcomeMessage = ({ 
  title = "Find your next destination and start planning your trip.",
  description = "Use the search bar above to enter a location or explore directly on the map."
}) => {
  return (
    <div className="welcome-sheet-message">
      <div className="welcome-title">{title}</div>
      <div className="welcome-desc">{description}</div>
    </div>
  );
};

export default WelcomeMessage; 